import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'

export const Container = styled(Flex).attrs({
  justifyContent: 'center',
  alignItems: 'center',
})`
  position: relative;
  overflow: hidden;
  background-color: ${themeGet('colors.bg.white')};
  color: ${themeGet('colors.white')};
`

export const Content = styled(Flex)`
  flex-direction: column;
`

export const Row = styled(Flex).attrs({
  alignItems: ['flex-start', 'flex-start', 'center'],
  flexDirection: ['column-reverse', 'column-reverse', 'row'],
})`
  width: 100%;
  justify-content: space-between;
`
